export default __webpack_public_path__ + "media/images/images_v2/bordure-action-0f526295968ce842e7e97d4926c65859.png";